export enum DialogSize {
  Small = 'small',
  Medium = 'medium',
  Big = 'big',
  Large = 'large',
  Fullscreen = 'fullscreen',
  FitContent = 'fit-content',
}

export enum ConfirmType {
  Primary = 'primary',
  Success = 'success',
  Warning = 'warning',
  Danger = 'danger',
}
